import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";

import self from "../../assets/Images/self.png";
import job from "../../assets/Images/job.png";
import feedback from "../../assets/Images/feedback.png";
import events from "../../assets/Images/events.png";
import personal from "../../assets/Images/reflection.png";



import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";


import "./LO.css"; // Import the CSS file

const LO5 = () => {
    const navigate = useNavigate();

    const cardslo5 = [
        {
            title: "Exploration of self",
            description: "",
            image: self,
            path: '/lo5/self'
        },

        {
            title: "Exploration of job vacancies",
            description: "",
            image: job,
            path: '/lo5/job'
        },

        {
            title: "Feedback",
            description: "",
            image: feedback,
            path: '/lo5/feedback'
        },

        {
            title: "Attending Events",
            description: "",
            image: events,
            path: '/lo5/attendingevents'
        },
        
        {
            title: "Reflection",
            description: "",
            image: personal,
            path: '/lo5/reflection'
        },
        

        
        



        
        
    ];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo5-headings">
                <h1>Personal Leadership</h1>
                {/* <p></p> */}

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                                <BreadcrumbHeader />
                        </div>

            <div className="content-lo5">
                <div className="content-lo5-card-container">
                    {cardslo5.map(({ title, description, image, path }, index) => (
                        <div 
                            key={index} 
                            className="card-lo5" 
                            onClick={() => navigate(path)} // Navigate to respective page
                        >
                            <img src={image} alt={title} className="card-lo5-image" />
                            <h3 className="card-lo5-title">{title}</h3>
                            <p className="card-lo5-description">{description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default LO5;